/**
 *
 * Dialog
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { ALIGNMENT, MAX_WIDTHS } from './constants';
import { StyledDialog } from './Dialog.styles';

const Dialog = ({
  maxWidth = MAX_WIDTHS.MD,
  align = ALIGNMENT.center,
  ...props
}) => <StyledDialog $align={align} maxWidth={maxWidth} {...props} />;

Dialog.propTypes = {
  align: PropTypes.oneOf(Object.keys(ALIGNMENT)),
  maxWidth: PropTypes.oneOf(Object.values(MAX_WIDTHS)),
};

export default memo(Dialog);
export { default as DialogActions } from './components/DialogActions';
export { DialogActionBackButton } from './components/DialogActions';
export { default as DialogFormActions } from './components/DialogFormActions';
export { default as DialogContent } from './components/DialogContent';
export { default as DialogDescription } from './components/DialogDescription';
export { default as DialogTitle } from './components/DialogTitle';
export { default as DialogSectionTitle } from './components/DialogSectionTitle';
